import React from "react";
import { Formik, Field, Form } from "formik";
import PropTypes from "prop-types";
import axios from "axios";
import VisitorAPI from "visitorapi";
import * as Yup from "yup";
import { startCase, toLower, get, trim } from "lodash";
import { fieldToTextField } from "formik-material-ui";

// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import MuiCheckbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { FormHelperText } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

// @material-ui/icons
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "~/material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "~/material-dashboard/components/Grid/GridItem.jsx";
import Button from "~/material-dashboard/components/CustomButtons/Button.jsx";
import Card from "~/material-dashboard/components/Card/Card.jsx";
import CardBody from "~/material-dashboard/components/Card/CardBody.jsx";

import TrustBox from "~/shared/widgets/TrustBox.jsx";
import TestimonialsCarousel from "~/shared/widgets/TestimonialsCarousel.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import AutocompleteUSStates, {
  stateSuggestions,
} from "./autocompleteUSStates.jsx";

import { Headline, FormikTextField, MAX_WIDTH } from "./shared.jsx";

import { identifyUser } from "~/shared/utils/analytics";
import { bugsnagClient } from "~/shared/utils/errorHandling";
import {
  getZerobounceAPIKey,
  supportedUSStates,
} from "~/shared/utils/sharedUtils";

import {
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY,
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP,
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA,
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP,
} from "~/shared/sharedConstants.js";

import {
  kickBlue,
  kickLightBlue,
  kickNavy,
} from "~/shared/styles/baseStyles.js";

import {
  setVisitUserCookies,
  clearUserAndVisitCookies,
  isLocalStorageAvailable,
  areCookiesAvailable,
  setIsPickup,
  setUserAlreadyExists,
} from "../utils/visitCookies";

const initialValues = {
  usState: { label: "", value: "" },
  firstName: "",
  lastName: "",
  email: "",
  terms: true,
};

const buttonStyles = {
  fontWeight: "bold",
  backgroundColor: kickBlue,
  textTransform: "none",
  fontSize: "14px",
};
const outlinedButtonStyles = {
  ...buttonStyles,
  border: "1px solid",
  backgroundColor: "white",
  color: kickBlue,
};

// const TextFieldUSStates = (props) => {
class TextFieldUSStates extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        style={{
          marginTop: "10px",
        }}
      >
        <AutocompleteUSStates
          {...fieldToTextField(this.props)}
          value={this.props.value}
        />
      </div>
    );
  }
}

function HowFastModal({ showPickupOrDelivery, setState }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Modal
      open={showPickupOrDelivery}
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        maxWidth: "1200px",
        margin: "auto",
        overflow: "scroll",
        justifyContent: isMobile ? "center" : "flex-start",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: isMobile ? "20px" : "40px",
          borderRadius: "8px",
          margin: isMobile ? "0 10px" : "0 40px",
          marginTop: isMobile ? "0" : "40px",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            color: kickNavy,
            fontFamily: "Spectral-Bold",
            fontSize: isMobile ? "28px" : "32px",
            margin: "20px 0",
            lineHeight: "normal",
          }}
        >
          Delivery or Pick-Up?
          {isMobile ? (
            <p
              style={{
                textAlign: "center",
                color: kickNavy,
                fontFamily: "Spectral-Bold",
                fontSize: isMobile ? "24px" : "26px",
                marginBottom: "30px",
                lineHeight: "normal",
              }}
            >
              The Choice is Yours
            </p>
          ) : (
            " The Choice is Yours"
          )}
        </h2>
        <p
          style={{ fontSize: "18px", marginBottom: "20px", lineHeight: "1.3" }}
        >
          Choose between delivery of meds to your doorstep for free, or same-day
          pickup at a local pharamcy.
        </p>
        <p
          style={{ fontSize: "18px", marginBottom: "20px", lineHeight: "1.3" }}
        >
          FedEx 2-day shipping is also available.
        </p>
        <p
          style={{ fontSize: "17px", marginBottom: "40px", lineHeight: "1.3" }}
        ></p>
        <div style={{ marginBottom: "20px" }}>
          <Button
            onClick={() => {
              setIsPickup(false);
              setState({ showPickupOrDelivery: false });
            }}
            style={{
              ...buttonStyles,
              width: isMobile ? "100%" : "auto",
              marginRight: isMobile ? "0" : "20px",
            }}
          >
            Delivery (arrives in 2 to 5 days)
            <br />
            Free shipping
          </Button>
          <Button
            onClick={() => {
              setIsPickup(true);
              setState({ showPickupOrDelivery: false });
            }}
            style={{
              ...outlinedButtonStyles,
              width: isMobile ? "100%" : "auto",
              marginRight: isMobile ? "0" : "16px",
            }}
          >
            Pick-Up (within a few hours)
          </Button>
          <a
            style={{
              cursor: "pointer",
              fontSize: "16px",
              width: isMobile ? "100%" : "auto",
              marginTop: isMobile ? "16px" : "0",
              textAlign: "center",
              display: "inline-block",
            }}
            onClick={() => {
              setState({ showPickupOrDelivery: false });
            }}
          >
            Decide Later
          </a>
        </div>
      </div>
    </Modal>
  );
}

class SignUp extends React.Component {
  emailAbstractValidated = false;

  constructor(props) {
    super(props);
    this.state = {
      consultationType: this.props.match.params.consultationType,
      checked: [],
      showComingSoon: false,
      signupError: "",
      visitorAPIRegion: "",
      initialStateSuggestion: null,
      showPickupOrDelivery: false,
      disableSubmit: false,
    };

    this.formRef = React.createRef();

    var item = sessionStorage.getItem("visApiData");

    var visApiData = item ? JSON.parse(item) : null;

    if (visApiData && visApiData.region) {
      var suggestion = stateSuggestions.find(
        (v) => v.value == visApiData.region.toUpperCase()
      );

      this.state.visitorApiRegion = visApiData.region;
      this.state.initialStateSuggestion = suggestion;
    } else {
      VisitorAPI("UDdQmAy3mVP0iw0mgWKQ")
        .then((data) => {
          // console.log("### visitor API data:", data);

          sessionStorage.setItem("visApiData", JSON.stringify(data));
          visApiData = data;

          var suggestion = stateSuggestions.find(
            (v) => v.value == visApiData.region.toUpperCase()
          );

          this.setState({
            visitorAPIRegion: visApiData.region,
            initialStateSuggestion: suggestion,
          });

          this.formRef.current?.props.formikProps.setFieldValue(
            "usState",
            suggestion
          );
        })
        .catch((error) => {
          console.error("Error calling visitorAPI: ", error);
        });
    }
  }

  disableSubmitAndGoBack() {
    this.setState({ disableButton: true });
    this.props.history.goBack();
  }

  componentDidMount() {
    // alert on ios - only support safari because of react-webcam not supporting WKV on iOS
    if (!isLocalStorageAvailable() || !areCookiesAvailable()) {
      alert(
        "Unfortunately your current browser isn't supported - Please disable incognito mode or try another browser or device."
      );
      this.disableSubmitAndGoBack();
      return;
    }

    clearUserAndVisitCookies();
    // clean old localstorage
    localStorage.clear();
    setTimeout(() => {
      this.setState({ showPickupOrDelivery: true });
    }, 400);
  }

  handleToggle = (value) => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked,
    });
  };

  validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("First Name is required.")
      .max(35, "First Name is too long"),
    lastName: Yup.string()
      .required("Last Name is required.")
      .max(35, "Last Name is too long"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required.")
      .max(35, "Email is too long"),
    usState: Yup.object().shape({
      value: Yup.string().required(),
    }),
    terms: Yup.boolean().oneOf(
      [true],
      "Please agree to terms and privacy policy to continue"
    ),
  });

  // TODO: refactor this to use react-hook-form and hooks
  TermsCheckbox = (props) => {
    return (
      <React.Fragment>
        <FormControlLabel
          control={
            <MuiCheckbox
              checked={props.field.value}
              onClick={(value) => {
                props.field.value == true
                  ? props.form.setFieldValue(props.field.name, null)
                  : props.form.setFieldValue(props.field.name, true);
              }}
              checkedIcon={<Check className={this.props.classes.checkedIcon} />}
              icon={<Check className={this.props.classes.uncheckedIcon} />}
              classes={{
                checked: this.props.classes.checked,
                root: this.props.classes.checkRoot,
              }}
            />
          }
          label={
            <span style={{ fontSize: "12px", color: kickBlue }}>
              I agree to{" "}
              <a
                href="/terms"
                target="_blank"
                style={{ textDecoration: "underline" }}
              >
                Terms of Use
              </a>{" "}
              <span style={{ fontSize: "12px" }}>&</span>{" "}
              <a
                href="/privacy"
                target="_blank"
                style={{ textDecoration: "underline" }}
              >
                Privacy Policy
              </a>
            </span>
          }
        />
        <FormHelperText
          error
          style={{ textAlign: "center", marginTop: "-8px" }}
        >
          {props.form.errors[props.field.name] != null
            ? "Please agree and click the checkbox to continue"
            : ""}
        </FormHelperText>
      </React.Fragment>
    );
  };
  validateEmail = async (email) => {
    let result = await this.validateEmailAbstractAPI(email);

    if (!result.emailValid) {
      result = await this.validateEmailZeroBounce(email);
      return result;
    }

    return result;
  };

  validateEmailAbstractAPI = async (email) => {
    const url = `https://emailvalidation.abstractapi.com/v1/?api_key=81c6f09d19cc4679b201a3ab23edba17&email=${email}`;

    try {
      const response = await axios.get(url);

      const data = response.data;

      if (data.deliverability == "DELIVERABLE") {
        this.emailAbstractValidated = true;
        return { emailValid: true };
      } else {
        // Email is not valid
        let suggestion = data.autocorrect
          ? `Did you mean: ${data.autocorrect}?`
          : null;

        return { emailValid: false, suggestion };
      }
    } catch (error) {
      console.error("Exception validating email:", error);
      return { emailValid: false };
    }
  };

  validateEmailZeroBounce = async (email) => {
    const url = `https://api.zerobounce.net/v2/validate?api_key=${getZerobounceAPIKey()}&email=${encodeURIComponent(
      email.trim()
    )}`;
    try {
      const response = await axios.get(url);

      const data = response.data;

      if (data.status === "valid") {
        this.emailAbstractValidated = true;
        return { emailValid: true };
      } else {
        let suggestion = data.did_you_mean
          ? `Did you mean: ${data.did_you_mean}?`
          : null;
        return { emailValid: false, suggestion };
      }
    } catch (error) {
      console.error("Exception validating email:", error);
      return { emailValid: false };
    }
  };

  emailOnChange = (e) => {
    this.emailAbstractValidated = false;

    let trimmedEmail = trim(e.target.value);
    if (trimmedEmail == "") {
      return;
    }

    this.validateEmail(trimmedEmail);
  };

  renderSignupForm() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {/* This takes most people about 10 minutes */}

        <CardBody
          style={{
            padding: "0",
            marginTop: "12px",
            maxWidth: MAX_WIDTH,
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            margin: "auto",
          }}
        >
          <Formik
            initialValues={{
              ...initialValues,
              // try to select the initial state based on visitor API geolocation
              ...{ usState: this.state.initialStateSuggestion },
            }}
            validationSchema={this.validationSchema}
            onSubmit={async (values, { setSubmitting, setErrors }) => {
              // email hasn't been validated yet... just return
              // if (!this.emailAbstractValidated) {
              //   return;
              // }

              let { emailValid, suggestion } = await this.validateEmail(
                values.email
              );

              if (!emailValid) {
                if (suggestion) {
                  setErrors({
                    email: `Could not validate email. ${suggestion}`,
                  });
                  return;
                } else {
                  setErrors({
                    email:
                      "Could not validate email. Please check and try again.",
                  });

                  return;
                }
              }

              const { firstName, lastName, email } = values;

              var signupValues = {
                firstName: firstName.trim(),
                lastName: lastName.trim(),
                email: email.trim(),
                usState: values.usState.value,
                consultationType: this.state.consultationType,
              };

              // Attach Rewardful details to signup values if they exist
              /*
                  if (Rewardful && Rewardful.referral) {
                    signupValues = {
                      ...signupValues,
                      signupReferralID: Rewardful.referral,
                      signupAffiliateID: get(Rewardful, "affiliate.id"),
                      signupCampaignID: get(Rewardful, "campaign.id"),
                      signupCouponID: get(Rewardful, "coupon.id"),
                    };
                  }
                   */

              // console.log("$$$ signupValues: ", signupValues);

              setSubmitting(true);
              axios
                .post("/api/v1/signup", signupValues)
                .then((response) => {
                  console.log("Response received:", response);
                  //
                  //
                  // not yet in the user's state - show coming soon
                  if (!supportedUSStates.includes(values.usState.value)) {
                    this.setState({ showComingSoon: true });
                    return;
                  }

                  const jsonData = response.data.data;
                  // console.log("jsonDATA:", jsonData);

                  // Block self referrals
                  if (
                    jsonData.attributes.affiliateID ===
                    window.Rewardful?.affiliate.id
                  ) {
                    delete window.Rewardful?.coupon;
                  }

                  setVisitUserCookies(jsonData);

                  // rewardful client-side conversion tracking. JANKY: only calling this in production because Rewardful doens't support stripe TEST environment yet, causing rewardful call to fail and cookie to get deleted
                  if (process.env.NODE_ENV == "master") {
                    if (rewardful && Rewardful.referral) {
                      rewardful("convert", {
                        email: toLower(email).trim(),
                      });
                    }
                  }

                  bugsnagClient.user = {
                    email: toLower(email).trim(),
                    name: startCase(`${firstName} ${lastName}`),
                  };

                  identifyUser(jsonData.id, {
                    email: toLower(email).trim(),
                  });

                  setSubmitting(false);

                  // T-139 submit form here for checking username, password etc
                  //
                  if (jsonData.attributes.apiTokenJWT) {
                    const location = {
                      pathname: `/visits/${this.state.consultationType}/signup-details`,
                      // state: { signUp: values }
                    };
                    this.props.history.push(location);
                  } else {
                    console.error("Error: Invalid Login Token received");
                  }
                })
                .catch((error) => {
                  setSubmitting(false);
                  if (error.response) {
                    if (error.response.status === 409) {
                      setUserAlreadyExists(
                        error.response.data?.data?.attributes?.email
                      );
                      window.location.href = "/me/";
                      return;
                    }
                    this.setState({
                      signupError: get(
                        error.response,
                        "data.errors[0].title",
                        ""
                      ),
                    });
                  }
                  console.error("Error signing up: ", error);
                  bugsnagClient.notify(error);
                })
                .finally(() => {
                  this.setState({ disableSubmit: false });
                });
            }}
          >
            {(props) => {
              return (
                <Form
                  data-rewardful="true"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Field
                    required
                    id="email"
                    name="email"
                    labeltext="Email Address"
                    placeholder="e.g. johndoe@gmail.com"
                    component={FormikTextField}
                    variant="outlined"
                    fullWidth
                    type="email"
                  />

                  <Field
                    id="firstName"
                    name="firstName"
                    labeltext="First Name"
                    placeholder="Your First Name"
                    component={FormikTextField}
                    variant="outlined"
                    fullWidth
                  />

                  <Field
                    id="lastName"
                    name="lastName"
                    labeltext="Last Name"
                    placeholder="Your Last Name"
                    component={FormikTextField}
                    variant="outlined"
                    fullWidth
                  />

                  <Field
                    id="usState"
                    name="usState"
                    formikProps={props}
                    innerRef={this.formRef}
                    initialValue={this.state.initialStateSuggestion}
                    component={TextFieldUSStates}
                    variant="outlined"
                    fullWidth
                  />
                  <div className={classes.center} style={{ marginTop: "20px" }}>
                    <Field
                      id="terms"
                      name="terms"
                      component={this.TermsCheckbox}
                      type="checkbox"
                    />

                    <div style={{ color: "red", margin: "6px auto 6px auto" }}>
                      <p style={{ textAlign: "center" }}>
                        {this.state.signupError}
                      </p>
                    </div>
                    <Button
                      disabled={!!this.state.disableSubmit}
                      onClick={() => {
                        this.setState({ disableSubmit: true }, () => {
                          props.submitForm();
                        });
                      }}
                      className={classes.signupButton}
                    >
                      {this.renderButtonLabel()}
                      {props.isSubmitting ? (
                        <CircularProgress
                          size="large"
                          style={{
                            position: "relative",
                            left: "24px",
                            top: "1px",
                            color: kickBlue,
                          }}
                        />
                      ) : null}
                    </Button>
                    <div style={{ marginTop: "4px" }}>
                      <a href="/me/">Login to your account</a>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </CardBody>
      </React.Fragment>
    );
  }

  renderBenefitHeadline() {
    var headline = "Let's Start Your Visit";
    switch (this.state.consultationType) {
      case CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY:
      case CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP:
        headline = "Let's Start Your Visit to Confidently Cool";
        break;

      case CONSULTATION_TYPE_ABBREVIATION_INSOMNIA:
      case CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP:
        headline =
          "Start Your Visit From 'Sleep Deprived' to 'Energized and Alive'";
        break;
    }
    return headline;
  }

  renderButtonLabel() {
    switch (this.state.consultationType) {
      case CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY:
      case CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP:
        return "Start Confidence Visit";

      case CONSULTATION_TYPE_ABBREVIATION_INSOMNIA:
      case CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP:
        return "Start Sleep Visit";
    }

    return "Start Visit";
  }

  renderSignupFormOrComingSoon() {
    const { classes } = this.props;
    if (!this.state.showComingSoon) {
      return this.renderSignupForm();
    } else {
      return (
        <React.Fragment>
          <h5 className={classes.signupComingSoonTitle}>
            Unfortunately we're not quite ready to prescribe in your area.
            {" We'll let you know as soon as we launch in your state."}
          </h5>
          <div
            style={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <p style={{ margin: "0 20px 0 20px" }}>
              Here are a few resources that might be helpful in the meantime:
            </p>
            <ul style={{ marginTop: "8px" }}>
              <li>
                <a href="/guides/anxiety/propranolol/">
                  Kick Guide to Calming Your Nerves With Propranolol
                </a>
              </li>
              <li>
                <a href="/guides/anxiety/xanax-vs-propranolol/">
                  Kick Guide to Xanax vs. Beta Blockers
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://doctor.webmd.com/"
                  rel="noreferrer"
                >
                  WebMD - Find a doctor near you
                </a>
              </li>
            </ul>
          </div>
          <div className={classes.center}>
            <a href="/">
              <Button
                color="primary"
                style={{ marginTop: "20px", width: "300px" }}
              >
                Back to Homepage
              </Button>
            </a>
          </div>
        </React.Fragment>
      );
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <>
        <HowFastModal
          showPickupOrDelivery={this.state.showPickupOrDelivery}
          setState={this.setState.bind(this)}
        />
        <div
          className={classes.container}
          style={{
            backgroundColor: "#3F3F82",
            transition: "opacity 400ms ease-in-out",
          }}
        >
          <GridContainer style={{ maxWidth: "1400px", margin: "auto" }}>
            <GridItem xs={12}>
              <Card className={classes.cardSignup}>
                <GridContainer
                  style={{
                    justifyContent: "center",
                  }}
                >
                  <GridItem
                    xs={12}
                    md={5}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "20px 0",
                    }}
                    className={classes.gridItemNoPadding}
                  >
                    <TrustBox className={classes.signupTrustbox} />
                    <Headline headline={this.renderBenefitHeadline()} />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        maxWidth: `${MAX_WIDTH}px`,
                        alignSelf: "center",
                        backgroundColor: kickLightBlue,
                        padding: "10px 16px",
                        borderRadius: "4px",
                      }}
                    >
                      <TestimonialsCarousel />
                    </div>
                  </GridItem>

                  <GridItem xs={12} md={7} style={{}}>
                    <div
                      style={{
                        margin: "10px auto 20px",
                        maxWidth: `${MAX_WIDTH}px`,
                        alignSelf: "center",
                      }}
                    >
                      <h4
                        className={this.props.classes.cardTitle}
                        style={{
                          color: kickBlue,
                          fontSize: "24px",
                          textAlign: "left",
                        }}
                      >
                        Your easy prescription intake only takes 10 minutes
                      </h4>

                      <p
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "14px",
                        }}
                      >
                        <Check
                          style={{
                            backgroundColor: kickBlue,
                            borderRadius: "100%",
                            color: "white",
                            fontSize: "17px",
                            padding: "2px",
                            marginRight: "8px",
                          }}
                          size="small"
                        />
                        <span>No appointment, video, or phone call needed</span>
                      </p>

                      <p
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "0px",
                        }}
                      >
                        <Check
                          style={{
                            backgroundColor: kickBlue,
                            borderRadius: "100%",
                            color: "white",
                            fontSize: "17px",
                            padding: "2px",
                            marginRight: "8px",
                          }}
                          size="small"
                        />
                        <span>Privately message your doctor anytime</span>
                      </p>
                    </div>

                    {this.renderSignupFormOrComingSoon()}
                  </GridItem>
                </GridContainer>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </>
    );
  }
}

SignUp.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(consultationStyles)(SignUp);
